import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  headerIconContainer: {
    marginRight: 20,
  },
  rightIcon: {
    marginLeft: 15,
  },
  chatIcon: {
    marginTop: 10,
  },
});
